import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Images from "../../Images";

const EditSubscription = ({
  editMutate,
  editLoading,
  setEditDetail,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    editMutate(values);
  };

  const formatDate = (date) => {
  if (!date) return "";
  return date.split(" ")[0];
};

const formik = useFormik({
  initialValues: {
    id: selectedData?. id || "",
    clientId: selectedData?.clientId || "",
    plan: selectedData?.plan || "",
    status: selectedData?.status || "",
    amount: selectedData?.amount || "",
    nextBillingDue: formatDate(selectedData?.nextBillingDue),
    startDate: formatDate(selectedData?.startDate),
    gracePeriod: selectedData?.gracePeriod || "",
    isGSTInvoice: selectedData?.isGSTInvoice ?? "",
    paymentLink: selectedData?.paymentLink || "",
    showRestrictionToStaff: selectedData?.showRestrictionToStaff ?? "",
  },

  validationSchema: Yup.object().shape({
   clientId: Yup.number().required("Please enter client ID"),
    plan: Yup.string().required("Please select a plan"),
    amount: Yup.string().required("Please enter amount"),
    startDate: Yup.string().required("Please select start date"),
    nextBillingDue: Yup.string().required("Please select next billing date"),
    gracePeriod: Yup.number().required("Grace period is required"),
    isGSTInvoice: Yup.number().required("Please select GST invoice"),
    // paymentLink: Yup.string().required("Please enter payment link"),
  }),

  onSubmit: SubmitHandler,

  enableReinitialize: true,
});



  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditDetail}>
      {editLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Details</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>

            <CombineInputGroup>
                <InputGroup>
                <Label htmlFor="clientId">Client ID</Label>
                <Input
                    name="clientId"
                    type=""
                    placeholder="Enter client ID"
                    value={formik.values.clientId}
                    onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    formik.setFieldValue("clientId", value);
                    }}
                    onBlur={formik.handleBlur}
                    autoComplete="off"
                    disabled
                    className="bg-gray-100"
                />
                {formik.touched.clientId && formik.errors.clientId && (
                    <ErrorText>{formik.errors.clientId}</ErrorText>
                )}
                </InputGroup>

                <InputGroup>
                    <Label htmlFor="status">Status</Label>
                    <FieldWrapper $select={true}>
                    <Select
                        name="status"
                        id="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        className="w-full pl-2"
                        style={{ height: "40px" }}
                        displayEmpty
                    >
                        <MenuItem value="" disabled>Select Status</MenuItem>
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="2">Payment Pending</MenuItem>
                        <MenuItem value="4">Account blocked</MenuItem>
                    </Select>
                    {formik.touched.status && formik.errors.status && (
                        <p className="text-rose-600 text-sm">
                        {formik.errors.status}
                        </p>
                    )}
                    </FieldWrapper>
                </InputGroup>
            </CombineInputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="plan">Plan</Label>
                <Select
                  className="w-full px-2"
                  name="plan"
                  value={formik.values.plan}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select Plan</MenuItem>
                  <MenuItem value="1">Basic</MenuItem>
                  <MenuItem value="2">Standard</MenuItem>
                  <MenuItem value="3">Premium</MenuItem>
                </Select>
                {formik.touched.plan && formik.errors.plan && (
                  <ErrorText>{formik.errors.plan}</ErrorText>
                )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="amount">Amount</Label>
                <Input
                  name="amount"
                  type=""
                  placeholder="Enter amount"
                  value={formik.values.amount}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only numbers and one decimal point
                    if (/^\d*\.?\d*$/.test(value)) {
                      formik.setFieldValue("amount", value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  autoComplete="off"
                />
                {formik.touched.amount && formik.errors.amount && (
                  <ErrorText>{formik.errors.amount}</ErrorText>
                )}
              </InputGroup>

            </CombineInputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="startDate">
                  Start Date
                </Label>
                <FieldWrapper>
                  <img
                    src={Images.Calender}
                    alt="Calendar icon"
                    className="absolute w-4 left-2 top-3"
                  />
                  <Input
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="pl-8"
                    value={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FieldWrapper>
                {formik.touched.startDate &&
                  formik.errors.startDate && (
                    <ErrorText>
                      {formik.errors.startDate}
                    </ErrorText>
                  )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="nextBillingDue">
                  Next Billing Due
                </Label>
                <FieldWrapper>
                  <img
                    src={Images.Calender}
                    alt="Calendar icon"
                    className="absolute w-4 left-2 top-3"
                  />
                  <Input
                    type="date"
                    name="nextBillingDue"
                    id="nextBillingDue"
                    className="pl-8"
                    value={formik.values.nextBillingDue}
                    min={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FieldWrapper>
                {formik.touched.nextBillingDue &&
                  formik.errors.nextBillingDue && (
                    <ErrorText>
                      {formik.errors.nextBillingDue}
                    </ErrorText>
                  )}
              </InputGroup>

            </CombineInputGroup>
 
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="isGSTInvoice">Is GST Invoice</Label>
                <Select
                  className="w-full px-2"
                  name="isGSTInvoice"
                  value={formik.values.isGSTInvoice}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Is GST Invoice</MenuItem>
                  <MenuItem value="1">YES</MenuItem>
                  <MenuItem value="0">NO</MenuItem>
                </Select>
                {formik.touched.isGSTInvoice && formik.errors.isGSTInvoice && (
                  <ErrorText>{formik.errors.isGSTInvoice}</ErrorText>
                )}
              </InputGroup>
              
                <InputGroup>
                <Label htmlFor="gracePeriod">Grace Period</Label>
                <Input
                    name="gracePeriod"
                    type=""
                    placeholder="Enter Grace Period"
                    value={formik.values.gracePeriod}
                    onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    formik.setFieldValue("gracePeriod", value);
                    }}
                    onBlur={formik.handleBlur}
                    autoComplete="off"
                />
                {formik.touched.gracePeriod && formik.errors.gracePeriod && (
                    <ErrorText>{formik.errors.gracePeriod}</ErrorText>
                )}
                </InputGroup>

            </CombineInputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="showRestrictionToStaff">Show Restriction To Staff</Label>
                <Select
                  className="w-full px-2"
                  name="showRestrictionToStaff"
                  value={formik.values.showRestrictionToStaff}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Show Restriction To Staff</MenuItem>
                  <MenuItem value="1">YES</MenuItem>
                  <MenuItem value="0">NO</MenuItem>
                </Select>
                {formik.touched.showRestrictionToStaff && formik.errors.showRestrictionToStaff && (
                  <ErrorText>{formik.errors.showRestrictionToStaff}</ErrorText>
                )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="paymentLink">Payment Link</Label>
                <FieldWrapper>
                    <Input
                    type="text"
                    name="paymentLink"
                    id="paymentLink"
                    value={formik.values.paymentLink}
                    onChange={formik.handleChange}
                    autoComplete="off"
                    className=""
                    />
                    {/* {formik.touched.paymentLink && formik.errors.paymentLink && (
                    <p className="text-rose-600 text-sm">
                        {formik.errors.paymentLink}
                    </p>
                    )} */}
                </FieldWrapper>
            </InputGroup>
            </CombineInputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full relative`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const ErrorText = tw.div`text-red-500 text-sm`;

export default EditSubscription;
